import React, {useEffect, useState} from 'react';
import {Autoplay} from 'swiper/modules';
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import {useRecoilValue} from 'recoil';
import {useNavigate} from 'react-router-dom';
import {Capacitor} from '@capacitor/core';
import {useTranslation} from 'react-i18next';

import {getMagazineCollectionProducts} from '@/services/magazine';
import {user} from '@/store';
import {addComma} from '@/utils';

import styles from './styles.module.scss';

interface ItemProps {
  title: string;
  price: string;
  img: string;
  discountNumber?: number;
  id: number;
  category: string;
}

const Item = ({title, price, img, discountNumber, category, id}: ItemProps) => {
  const navigator = useNavigate();
  return (
    <div
      className={styles.collectionItem}
      onClick={() => {
        navigator(`/${category}/${id}`);
      }}>
      <div className={styles.imgWrapper}>
        <img src={img} alt="" />
        {discountNumber && discountNumber > 0 ? (
          <div className={styles.imgBadge}>{discountNumber}%</div>
        ) : (
          <></>
        )}
      </div>
      <div className={styles.txtWrapper}>
        <div className={styles.itemTitle}>{title}</div>
        <div className={styles.itemDesc}>
          {discountNumber && discountNumber > 0 ? (
            <span>{discountNumber}%</span>
          ) : (
            <></>
          )}
          <>{`${addComma(Number(price))}원`}</>
        </div>
      </div>
    </div>
  );
};
export default function CollectionTop() {
  const [list, setList] = useState<CollectionListItem[]>();
  const accessToken = useRecoilValue(user);
  const {t} = useTranslation(['views'], {keyPrefix: 'collection.Top'});

  const getMagazineItem = async () => {
    const result = await getMagazineCollectionProducts(accessToken);
    setList(result?.data?.products);
  };

  useEffect(() => {
    getMagazineItem();
  }, []);
  return (
    <div
      className={`${styles.collection_top}  ${
        Capacitor.getPlatform() === 'android'
          ? styles.android
          : Capacitor.getPlatform() === 'ios'
          ? styles.ios
          : styles.web
      }`}>
      <h2 className={styles.title}>ONLY Knewnew</h2>
      <p className={styles.desc}>{t('desc')}</p>
      <div className={styles.swiperWrapper}>
        <Swiper
          className="mySwiper"
          initialSlide={0}
          slidesPerView={'auto'}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          centeredSlides={true}
          modules={[Autoplay]}
          spaceBetween={0}
          slideToClickedSlide={true}
          loop={Capacitor.getPlatform() !== 'android' || false}>
          {list?.map((item, index) => (
            <SwiperSlide key={`slide-item-${index}`}>
              <Item
                title={item.title}
                price={item.price}
                img={
                  item.collectionImageUrl
                    ? item.collectionImageUrl
                    : item.imageUrl
                }
                discountNumber={item.discountNumber}
                id={item.id}
                category={item.category}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
